import MomentsUploadForm from './MomentsUploadForm';

const CustomerUploadForm = props => {
  const {
    onClose,
    action,
    onSubmit,
    customer
  } = props;

  let jobId = customer.job_id;
  let isDefault = false;
  let customerIds = [customer.id];
  let storyIds = [customer.story_id];
  let hideJobSelect = true;
  let hideDefaultCheckbox = true;
  let hideCustomerSelect = true;

  return <MomentsUploadForm {...{
    onClose,
    action,
    onSubmit,
    jobId,
    isDefault,
    customerIds,
    storyIds,
    hideJobSelect,
    hideDefaultCheckbox,
    hideCustomerSelect
  }} />;
}

export default CustomerUploadForm;
